module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }), _vm._v("MAN")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man is a degenerate, degraded thing. He is a thing that seized upon the insolent plan of delving into the condition of its existence. It surrendered its immaculate positivity in exchange for the fateful capacity to be able to say no, to oppose something, to deny, to forbid, to obstruct, to nihilate. This capacity it acquired by implanting in itself nothingness, the root of all negation. Then it could say “I am not that” or “This is not that.” The thing acquired consciousness and changed from an in-itself to a for-itself. Along with consciousness it received the questionable gift of freedom, this for-itself could select from its possibilities an end and project itself toward this end. As a result of its choice and its project the for-itself became a man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man is the being who brought into the world nothingness and with nothingness the possibility of nihilating something. “But what am I if not a certain internal negation of the in-itself? Without this in-itself which I deny, I should vanish into nothingness.”"), _c('a', {
    attrs: {
      "id": "ch03fn1"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We shall never apprehend ourselves except as a choice in the making. But freedom is simply the fact that this choice is always unconditioned.”"), _c('a', {
    attrs: {
      "id": "ch03fn2"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The for-itself in order to choose itself as a person effects the existence of an internal organization which the for-itself surpasses toward itself, and this internal technical organization (for the appropiation of the world or for living in harmony with others, since these processes are the collective property of mankind, of national, professional, and family groups) is his human or national quality.”"), _c('a', {
    attrs: {
      "id": "ch03fn3"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since man is descended from things (from lumps of clay into which God breathed: there was a void in which no thing, no in-itself, nothing was; there existed in the thing a place on which nothingness could settle), he participates in the contingency of things, in their fortuitousness, in their non-urgency, in their groundlessness. One characteristic of man is therefore his facticity, that is, the for-itself’s necessary connection with the in-itself, which makes it possible for him to assert that he "), _c('i', [_vm._v("is")]), _vm._v(" and that he is as he is. Man has "), _c('i', [_vm._v("Dasein")]), _vm._v(" (“being-there”), he exists; but he is “cast” there, that is, he not only is but has to be there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main employment of man is to recover the being-in-itself of things and all the while be for himself—not to merge with the world of things but to incorporate it in himself. His desire is therefore to be in-and-for-itself, to become the proof and foundation of his self (an "), _c('i', [_vm._v("ens causa sui")]), _vm._v("); he wishes to free himself from contingency, that is, to become God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Christ sacrificed himself in order to bring into being the true man; man destroys himself in his striving after being-in-and-for-itself in order to bring into being God. The true meaning of human behavior therefore transcends egoism, altruism, and disinterest. “Man makes himself man in order to be God,”"), _c('a', {
    attrs: {
      "id": "ch03fn4"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" that is, to become his own foundation. But since “there is no common measure between human reality and the self-cause which it wants to be, one could just as well say that man loses himself in order that the self-cause may exist.”"), _c('a', {
    attrs: {
      "id": "ch03fn5"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Being-a-man is being-in-the-world, and man can not tear himself away from the world unless he tears himself away from himself. He actually does this in doubt, in interrogation, in suspension of judgement, etc. Here one state of consciousness is wrenched away from another that immediately precedes and motivates it, with the result that a caesura is produced. This caesura is nothingness. Nothingness is impregnable precisely because it is nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a consequence of his freedom man is always separated by nothingness from what he has just been, that is, from his being. Never can a man’s act be explained by what can be asserted about him, for man "), _c('i', [_vm._v("is")]), _vm._v(" what he has been. An act, on the contrary, is actual; it anticipates the future and always trascends man’s being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If a man directs his undivided attention toward something and actively gives himself over to it, his conduct has no “outside” (that is, he does not observe it); “it is merely a process of relating the instruments … to the end to be attained, a pure mode of losing myself in the world, of causing myself to be drunk in by the things as ink is by a blotter in order that an instrumental complex oriented toward an end may be synthetically detached from the ground of the world.”"), _c('a', {
    attrs: {
      "id": "ch03fn6"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A man can not actually make himself an object of cognition. An object is what my consciousness is not and what has in itself no trace of consciousness. For outside my own consciousness there is nothing that has for me the characteristics of consciousness. A self that I have made into my object is therefore a self that is not my self. For even if I could see myself clearly and distinctly as an object, what I saw would still not be an adequate representation of what I am in and for myself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man’s being is tied not only to his being-for-itself but also to his being-for-others. Both the upsurge of my consciousness and the upsurge of my being-for-others have the character of absolute events. My being-for-others is the first fact that I meet with, and the one that I meet with continuously. At all events I must be the one who is "), _c('i', [_vm._v("not")]), _vm._v(" something else or the Other. In this negation directed toward myself I bring myself into being, I become my Self and the Other emerges. To produce the Other, my consciousness must have the faculty “not to be” the Other; it must therefore spontaneously wrench itself away from the Other (who “is” my consciousness to begin with) and choose for itself non-being. This non-being is the Other as such. My being-for-myself invests the Other not with being but rather with otherness, the characteristic of being someone besides me. “It is necessary that the other be present to consciousness in every part and even that it penetrate consciousness completely in order that conscious precisely by "), _c('i', [_vm._v("being nothing")]), _vm._v(" may escape the Other who threatens to ensnare it. If consciousness were abruptly to be something, the distinction between itself and the Other would disappear at the heart of undifferentiation.”"), _c('a', {
    attrs: {
      "id": "ch03fn7"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" The Other is of course (in contrast to things-in-themselves) exactly what I myself am: for-itself and consciousness. He therefore has the same mode of being as I. By excluding the Other he is myself. “The Other exists for consciousness only as a "), _c('i', [_vm._v("refused self")]), _vm._v(",”"), _c('a', {
    attrs: {
      "id": "ch03fn8"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" that is, I exist for myself as the self that has been refused by him, and only as that self. “Thus the Other whom I recognize in order to refuse to be him is before all else the one "), _c('i', [_vm._v("for whom my for-itself is")]), _vm._v(".”"), _c('a', {
    attrs: {
      "id": "ch03fn9"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" But I nevertheless refuse to be a self through which the Other can make me into an object (in his judgment, etc.),")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thus my being-for-others … is a perfectly real being, my being as the condition of my selfness confronting the Other and of the Other’s selfness confronting me.”"), _c('a', {
    attrs: {
      "id": "ch03fn10"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shame, the feeling of man’s original fall, results not from the fact that I have committed a particular wrong but simply from the fact “that I have ‘fallen’ into the world in the midst of things”"), _c('a', {
    attrs: {
      "id": "ch03fn11"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" and must have the help of the Other to overcome objectness and be what I am.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Adam and Eve realized after the fall that they were naked because the naked body symbolizes our brute objectivity. Putting on clothing signifies laying claim to the right of being the subject, of seeing without being seen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I “am” my possibilities, and the order of the instruments that are in the world “is the image of my possibilities,”"), _c('a', {
    attrs: {
      "id": "ch03fn12"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" that is, the image of what I am. Through action I unknowingly adapt myself to this image. The Other, whom I have made an object (in my judgment, etc.) is an instrument defined for me through its relations to all other instruments. I also apprehend the Other in terms of his organization of the world around him (since he in turn makes the world a totality of "), _c('i', [_vm._v("his")]), _vm._v(" instruments), but the whole remains my microcosmos. Nothing is irretrievably lost. On the contrary the world reveals to me the Other together with his situation, that is, as a unity which extends throughout “the whole world as a mundane power for the synthetic organization of this world.”"), _c('a', {
    attrs: {
      "id": "ch03fn13"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I structure in a wholly different manner the world in which I make the Other an object. I can never apprehend a situation as it appears to the other, and I can always be mistaken concerning the Other’s intentions. It would be different if I could apprehend and communicate with the Other as subject. But that is impossible. As soon as I turn toward him, I make him and his world into objects of my world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The for-itself, which constitutes the essence of man, is the nihilation of the in-itself; it is a degraded thing bereft of being-in-itself. Through nihilation it did indeed achieve consciousness, but it had at the same time to take upon itself the burden of facticity—a body, the quality of a “given” with respect to others, a preterite which defined it. It seeks henceforth to escape its factual existence, that is, “its being-there as an in-itself for which there is no foundation.”"), _c('a', {
    attrs: {
      "id": "ch03fn14"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Always pursued, it flees toward an impossible future where the for-itself would be in-itself-for-itself—an in-itself with its own foundation (and not something for an outside observer). It nihilates and flees from the in-itself which is at the same time pursuing it. The for-itself is a pursued-pursuing. It is both flight and pursuit and can not be distinguished from its two-directional movement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The continuous flight which constitutes the being of man comes to a sudden stop when the Other emerges, for the Other sees it and changes it thereby into an object, an in-itself. The reason is that for the Other I am unalterably what I actually am, and even my freedom becomes a mere quality of my being, a given; it ceases to be something experienced. I experience my objectivity as an alienation of my self, and it confers on my flight the character of the in-itself before which it flees. The in-itself recaptures me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Such is the origin of my concrete relations with the Other; they are wholly governed by my attitudes with respect to the object which I am for the Other.”"), _c('a', {
    attrs: {
      "id": "ch03fn15"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" The Other can look on me and know what I am; I can not know what I am, however, for I can not conceive of myself as an object. “Thus the profound meaning of my being is outside of me.”"), _c('a', {
    attrs: {
      "id": "ch03fn16"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Since it is the Other’s freedom that I have sought to make the foundation on my being-in-itself, I try to appropiate for myself this freedom, yet in such a way that it will remain an active freedom experienced and manifested by the Other. That would happen if I could incorporate his freedom. Then I would become "), _c('i', [_vm._v("for myself")]), _vm._v(" my own foundation, and would attain the goal of my pursuing flight. My being consists therefore in the continuously repeated attempt to make the Other an object (in order to my own foundation). “These two attempts which I am are opposed to one another.”"), _c('a', {
    attrs: {
      "id": "ch03fn17"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" If one succeeds, the other fails; the failure of either motivates the adoption of the other. These two attempts, always simultaneously undertaken, are the basis for my behavior with respect to the Other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My relations to the Other are interchangeable. “While I attempt to free myself from the hold of the Other (who wishes to make me his object), the Other is trying to free himself from mine; while I seek to enslave the Other, the Other seeks to enslave me.”"), _c('a', {
    attrs: {
      "id": "ch03fn18"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" The original meaning of being-for-others (my being-for-others and the being-for-others or being-for-me of the Other) is this conflict, not Heidegger’s "), _c('i', [_vm._v("Mit-sein")]), _vm._v(" (“being with”).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Being-for-itself is synonymous with the nihilation of the in-itself which it actually is, and with inner negation of the in-itself which it is not. It trascends the world and causes there to be things. Man’s being has the dual characteristic of being facticity and trancendence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Other by rising up confers on the for-itself a being-in-itself-in-the-midst-of-the-world as a thing among things. This petrification in in-itself by the Other’s look is the profound meaning of the myth of Medusa.”"), _c('a', {
    attrs: {
      "id": "ch03fn19"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Of course the in-itself to which the for-itself changes under the Other’s look is but the outside of the for-itself. For myself I am always a person completely different from the one that I am for the Other. “The for-itself by nature is the being which can not coincide with its being-in-itself.”"), _c('a', {
    attrs: {
      "id": "ch03fn20"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In several respects the human reality has to be its own nothingness. “First by temporalizing itself—i.e., by always being at a distance from itself, which means that it can never let itself be determined by its past to perform this or that particular act; second, by rising up as consciousness of something and (of) itself—i.e., by being presence to itself and not simply self, which implies that nothing exists in consciousness which is not consciousness of existing and that consequently nothing external to consciousness can motivate it; and finally, by being trascendence—i.e., not something which would "), _c('i', [_vm._v("first")]), _vm._v(" be in order subsequently to put itself into relation with this or that end, but on the contrary a being which is originally a project—i.e., which is defined by its end.”"), _c('a', {
    attrs: {
      "id": "ch03fn21"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The world, because of its very articulation, “necessarily appears to us as we are. In fact, it is by surpassing the world toward ourselves that we make it appear as it is. We choose the world, not in its contexture as in-itself but in its meaning, by choosing ourselves.”"), _c('a', {
    attrs: {
      "id": "ch03fn22"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" By denying that we are the world (internal negation of the world) we allow it to appear as world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For human reality being is reduced to acting. Being human is an articulated unity of actions. Acting is not a "), _c('i', [_vm._v("consequence")]), _vm._v(" of anything at all in the world or in man; it is rather the "), _c('i', [_vm._v("expression")]), _vm._v(" of freedom; it is independent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every act is an expression of our freedom to the extent that it manifests itself as effluence of the original choice which we ourselves are; the act can therefore can not be done or compensated for by another even though the original choice can be changed or is changed. That a change is always possible is attested by anguish. For in anguish we are distressed when confronted by ourselves as by one who can at any time change, on whom we can not rely for the very reason that he is free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because the choice by which I have chosen myself is constantly being threatened and the possibilities unfolded by it eaten away by my freedom, I must constantly reassume it. When the new choice is made, “consciousness posits its own past as an object; that is, it "), _c('i', [_vm._v("evaluates")]), _vm._v(" its past and takes its bearings in relation to it [though it is not determined by the past]. This act of objectivizing the immediate past is the same as the new choice of other ends.”"), _c('a', {
    attrs: {
      "id": "ch03fn23"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Was it possible for Adam to take the apple? Yes, but only if he changed his original choice and became a different Adam. But along with this new Adam would also have emerged a new world, and whether or not Eve would have been a part of it is unknown. The Biblical Adam could not choose to be himself (he received his being from God) and bore no responsibility for his being, that is, for his commissions and omissions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Intention")]), _vm._v(" is the fundamental structure of human reality and this means that we must go beyond the given toward a result to be achieved. For this reason it can never be explained by a given (whether physical, mental, or spiritual). Nor is the end given; rather “the intention makes itself be by choosing the end which makes it known.”"), _c('a', {
    attrs: {
      "id": "ch03fn24"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" The intentional choice of the end reveals the world, not as it is but as it ought to be. The intention is nonthetic consciousness of possibilities and therefore thetic consciousness of the end. The given is judged in terms of the end: “It is in the light of non-being [the end is still nonexistent for it lies in the future, and only that which is present can be] that being-in-itself is illuminated.”"), _c('a', {
    attrs: {
      "id": "ch03fn25"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“To be free is to-be-free-to-do.”"), _c('a', {
    attrs: {
      "id": "ch03fn26"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" This assumes that there is something independent of my existence and action. My action can reveal to me this something but is not dependent on it. “To do is precisely to change what has no need of something other than itself in order to exist; it is to act on that which on principle is indifferent to action, that which can pursue its existence or its becoming without the action.”"), _c('a', {
    attrs: {
      "id": "ch03fn27"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Human reality, since it is action, “can be conceived only as being at its core a rupture with the given. It is the being which "), _c('i', [_vm._v("causes there to be a given")]), _vm._v(" by breaking with it and illuminating it in the light of the not-yet-existing,”"), _c('a', {
    attrs: {
      "id": "ch03fn28"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" that is, the end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The for-itself is free and “can cause there to be a world because … (it) is the being which has to be what it was in the light of what it will be,”"), _c('a', {
    attrs: {
      "id": "ch03fn29"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" that is, what it has been, in keeping with the Hegelian formula, “Essence is what has been.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Man encounters an obstacle only within the field of his freedom.… There is no obstacle in an absolute sense, but the obstacle reveals its coefficient of adversity across freely invented and freely acquired techniques. The obstacle reveals this coefficient also in terms of the value of the end posited by freedom.”"), _c('a', {
    attrs: {
      "id": "ch03fn30"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man can project his future but can not choose his past. “The past is that which is out of reach and which haunts us at a distance.”"), _c('a', {
    attrs: {
      "id": "ch03fn31"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We must make each new decision in terms of the past even though no decision is determined by the past. “The past is present and melts insensibly into the present … all that I am I have to be in the mode of having been.… Thus the importance of the past can not be exaggerated since for me ‘"), _c('i', [_vm._v("Wesen ist was gewesen ist")]), _vm._v(",’ essence is what has been.”"), _c('a', {
    attrs: {
      "id": "ch03fn32"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Against this, the past is only what is in relation to the end freely chosen through freedom, for it is from this end that it derives its meaning and consequently its importance. “By projecting myself toward my ends, I preserve the past with me, and by action I decide its meaning.”"), _c('a', {
    attrs: {
      "id": "ch03fn33"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" The future “decides whether the past is living or dead.”"), _c('a', {
    attrs: {
      "id": "ch03fn34"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Once I decide through my action that the past has meaning for me, it becomes an integrating component and a necessary condition of my decision. Thus I “will” my past, and willing it means realizing it “by a thousand secondary behaviors.”"), _c('a', {
    attrs: {
      "id": "ch03fn35"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" If I decide the opposite, then the past exists only as “"), _c('i', [_vm._v("that self which I no longer am—i.e")]), _vm._v("., that being which I have "), _c('i', [_vm._v("to be as the self which I am no longer")]), _vm._v(".”"), _c('a', {
    attrs: {
      "id": "ch03fn36"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The extreme possibility toward which the for-itself can be projected is that of "), _c('i', [_vm._v("seeing oneself")]), _vm._v(", that is, of becoming someone else in order to be able to see oneself from the outside (the magical attraction of the looking-glass).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man is condemned to be free and therefore to bear the weight of the whole world on his shoulders. The for-itself is the prime mover of the world and itself, and therefore must wholly assume the situation together with “its peculiar coefficient of adversity, even though it be insupportable.… The very worst disadvantages or the worst threats which can endanger my person have meaning only in and through my project.… It is therefore senseless to think of complaining since nothing foreign has decided what we feel, what we live, or what we are.… What happens to me happens through me, and I can neither affect myself with it nor revolt against it nor resign myself to it.”"), _c('a', {
    attrs: {
      "id": "ch03fn37"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" I am always the focal point of everything that happens to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In anguish in the face of his freedom, man is nothing other than a freedom “which perfectly reveals itself and whose being resides in this very revelation.”"), _c('a', {
    attrs: {
      "id": "ch03fn38"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" The one who in anguish realizes his condition “has no longer either remorse or regret or excuse.”"), _c('a', {
    attrs: {
      "id": "ch03fn39"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Man is the pursuit of being; the real goal of his pursuit is a “synthetic fusion of the in-itself with the for-itself.”"), _c('a', {
    attrs: {
      "id": "ch03fn40"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Those who know the real goal of their pursuit “refrain from appropriating things for their own sake and try to realize the symbolic appropriation of their being-in-itself.”"), _c('a', {
    attrs: {
      "id": "ch03fn41"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Human freedom, which man becomes conscious of in anguish, is the sole source of value, for it reveals the nothingness through which the world exists. “As soon as freedom discovers the quest for being and the appropriation of the in-itself as its "), _c('i', [_vm._v("own possibles")]), _vm._v(", it will apprehend by and in anguish that they are possibles only on the ground of the possibility of the other possibles.”"), _c('a', {
    attrs: {
      "id": "ch03fn42"
    }
  }), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/reference#ch03fn42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" But choice with respect to these possible is guided by the value conferred on them by freedom or by the ideal presence of the "), _c('i', [_vm._v("ens causa sui")]), _vm._v(" or ultimate Being—the final even though unattainable human goal.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a4fb5e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 78
// module chunks = 0